import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {
  CartPageComponent,
  CartPaySystemsResolver
} from './cart-page/cart-page.component';
import { OrderSuccessComponent } from './order-success/order-success.component';

const routes: Routes = [
  {
    path: '',
    component: CartPageComponent,
    resolve: {
      data: CartPaySystemsResolver
    }
  },
  {
    path: 'order-success',
    component: OrderSuccessComponent,
  }
];

@NgModule({
  imports: [
    RouterModule.forChild(routes)
  ],
  providers: [
    CartPaySystemsResolver,
  ],
  exports: [
    RouterModule
  ]
})
export class CartRouterModule {}
